import styled from "@emotion/styled"

const EventListItemTag = styled.span`
  margin-block-start: 0;
  margin-block-end: 0;
  letter-spacing: 0.06em;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;

  ${({ theme }) => theme.breakpoints.down("xl")} {
    line-height: 34px;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    line-height: 32px;
  }
`

export default EventListItemTag
